<appTable v-if="shouldRenderConfig" :tableName="name"  v-bind:tableClass="getClassName">
    <slot></slot>    
</appTable>